"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("./style");
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Switch = _ref => {
  let {
    label,
    id,
    disabled,
    handleSwitch,
    isOn
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.Container, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlFor: id,
    type: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_style.Wrapper, null, /*#__PURE__*/_react.default.createElement(_style.Input, {
    checked: isOn,
    onChange: handleSwitch,
    id: id,
    type: "checkbox",
    role: "switch",
    "aria-checked": isOn,
    "aria-readonly": disabled,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_style.Span, {
    "aria-hidden": "true"
  })));
};
Switch.propTypes = {
  label: _propTypes.default.string.isRequired,
  isOn: _propTypes.default.bool,
  id: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  handleSwitch: _propTypes.default.func.isRequired
};
Switch.defaultProps = {
  disabled: false,
  isOn: false
};
var _default = exports.default = Switch;